import { TradelineNewState } from 'api/ApplicationDataApi';
import { LoanType, Tradeline } from 'handlers/applicationData';

export const MINIMUM_BALANCE = 100;

export const sortTradeLinesByAprAndBalanceDesc = (tradelines: Tradeline[]): Tradeline[] =>
  tradelines.sort((a, b) => {
    // Prioritize tradelines with user-overridden balances
    const aHasOverride = !!a.userOverriddenBalanceToConsolidate;
    const bHasOverride = !!b.userOverriddenBalanceToConsolidate;

    if (aHasOverride && !bHasOverride) return -1;
    if (!aHasOverride && bHasOverride) return 1;
    const aprDiff: number = b.apr! - a.apr!;
    const balanceDiff: number = b.balance! - a.balance!;

    if (aprDiff === 0) {
      if (a.loanType === LoanType.CreditCard && b.loanType !== LoanType.CreditCard) {
        return -1;
      }

      if (b.loanType === LoanType.CreditCard && a.loanType !== LoanType.CreditCard) {
        return 1;
      }

      return balanceDiff;
    }

    return aprDiff;
  });

export const setTradelinesForConsolidationAndCalculateBalance = (
  tradelines: Tradeline[],
  maxLoanAmount: number,
): (Tradeline & { madeChanges?: boolean })[] => {
  let debtConsolidationAmount = 0;
  const t = sortTradeLinesByAprAndBalanceDesc(tradelines).map((tradeline: Tradeline) => {
    let balanceToConsolidate = 0;

    if (tradeline.userOverriddenBalanceToConsolidate) {
      balanceToConsolidate = tradeline.userOverriddenBalanceToConsolidate;
      debtConsolidationAmount += tradeline.userOverriddenBalanceToConsolidate;
    } else if (debtConsolidationAmount + MINIMUM_BALANCE <= maxLoanAmount) {
      if (debtConsolidationAmount + tradeline.balance! <= maxLoanAmount) {
        debtConsolidationAmount += tradeline.balance!;
        balanceToConsolidate = tradeline.balance!;
      } else {
        balanceToConsolidate = maxLoanAmount - debtConsolidationAmount;
        debtConsolidationAmount = maxLoanAmount;
      }
    }

    return {
      ...tradeline,
      balanceToConsolidate,
      selectedForConsolidation: true,
      madeChanges: balanceToConsolidate !== tradeline.balanceToConsolidate,
    };
  });
  return t.filter((tradeline) => tradeline.madeChanges);
};
export const convertTradelineNewStateToBoolean = (newState: TradelineNewState | undefined) => {
  switch (newState) {
    case TradelineNewState.Selected:
      return true;
    case TradelineNewState.Unselected:
      return false;
    default:
      return undefined;
  }
};
